var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleContentBlock',{attrs:{"centered":""}},[_c('CycleHtml',{attrs:{"html":_vm.introText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }